import Enum from "../../../enums/Enum";

const PsychologyFormTextEnum = new Enum({
    Form_Title: { English: "CLINICAL PSYCHOLOGY INFORMED CONSENT FORM", Arabic: "الموافقة المستنيرة على العلاج النفسي السريري" },
    Form_Header: { English: "Clinical Psychology Consent Form", Arabic: "الموافقة المستنيرة على العلاج النفسي السريري" },

    Patient_Information: { English: "Patient information:", Arabic: "معلومات المريض:" },
    Name: { English: "Name:", Arabic: "الاسم:" },
    MRN: { English: "MRN:", Arabic: "رقم السجل الطبي:" },
    DOB: { English: "D.O.B:", Arabic: "تاريخ الميلاد:" },

    Electronic_Systems: { English: "Electronic systems:", Arabic: "الأنظمة الإلكترونية:" },
    Electronic_Systems_Description: {
        English: "Electronic systems used will incorporate network and software security protocols to protect confidentiality of patient identification and imaging data and will include measures to safeguard the data and to ensure its integrity against intentional and unintentional corruption in accordance with the Laws and Regulations.",
        Arabic: "ستتضمن الأنظمة الإلكترونية المستخدمة بروتوكولات أمان الشبكة والبرمجيات لحماية سرية بيانات هوية المريض والتصوير، وستتضمن تدابير لحماية البيانات وضمان سلامتها ضد الفساد المتعمد وغير المتعمد وفقًا لقوانين وأنظمة دولة الإمارات العربية المتحدة."
    },

    Nature_Of_Teleconsultation: { English: "Nature of Teleconsultation:", Arabic: "طبيعة الاستشارة عن بعد:" },
    Nature_Of_Teleconsultation_Description: {
        English: "During the teleconsultation",
        Arabic: "أثناء الاستشارة عن بعد"
    },

    Nature_Of_Teleconsultation_Point1: {
        English: "Details of your medical history, examinations, x-rays and tests may be discussed with other healthcare professionals with interactive videos, audio and telecommunication technology.",
        Arabic: "قد تتم مناقشة تفاصيل تاريخك الطبي والفحوصات والأشعة السينية والاختبارات مع متخصصين آخرين في الرعاية الصحية من خلال مقاطع فيديو تفاعلية وتقنية صوتية واتصالات."
    },

    Nature_Of_Teleconsultation_Point2: {
        English: "Upon your approval, audio and/or photo recordings may be taken for accurate diagnosis, treatment and quality control.",
        Arabic: "بعد الحصول على موافقتك، قد يتم أخذ تسجيلات صوتية و/أو صورية للتشخيص الدقيق والعلاج ومراقبة الجودة."
    },

    Medical_Information_And_Records: { English: "Medical Information and Records:", Arabic: "المعلومات والسجلات الطبية:" },
    Medical_Information_Description: {
        English: "All existing federal laws and local regulations/policies/guidelines regarding access to medical information and copies of your Health Records apply to this teleconsultation. Dissemination of any patient identifiable images or information for this telehealth interaction to other entities will not take place    without your consent.",
        Arabic: "تنطبق على هذه الاستشارة عن بعد جميع القوانين الفيدرالية واللوائح/السياسات/المبادئ التوجيهية المحلية الحالية فيما يتعلق بالوصول إلى المعلومات الطبية ونسخ من سجلاتك الصحية. لن يتم نشر أي صور أو معلومات يمكن التعرف على هوية المريض من خلالها فيما يتعلق بهذا التفاعل عن بعد مع جهات أخرى دون موافقتك."
    },

    Confidentiality: { English: "Confidentiality:", Arabic: "السرية:" },
    Confidentiality_Description: {
        English: "Responsible and appropriate efforts have been made to eliminate any confidentiality risks associated with the teleconsultation and all existing confidentiality protections under the federal laws and     local regulation apply to information disclosed during this teleconsultation.",
        Arabic: "تم بذل جهود مناسبة للقضاء على أي مخاطر تتعلق بالسرية المرتبطة بالاستشارة عن بعد، وتنطبق جميع تدابير حماية السرية الحالية بموجب القوانين الاتحادية لدولة الإمارات العربية المتحدة واللوائح المحلية على المعلومات التي تم الكشف عنها أثناء هذه الاستشارة عن بعد."
    },

    Rights: { English: "Rights:", Arabic: "الحقوق:" },
    Rights_Description: {
        English: "You may withhold or withdraw consent to teleconsultation at any time without affecting your right to future care or treatment. You will be advised of all the risks, consequences and benefits of teleconsultation. Your treating physician will discuss with you the information provided in a language you can understand. You will be given the opportunity to ask questions about the information presented in this form and about the teleconsultation. ",
        Arabic: "يمكنك حجب أو سحب موافقتك على الاستشارة عن بُعد في أي وقت دون المساس بحقك في الرعاية أو العلاج مستقبلاً. سيتم إبلاغك بجميع مخاطر وعواقب وفوائد الاستشارة عن بُعد. سيناقش طبيبك المعالج معك المعلومات المُقدمة بلغة تفهمها. ستتاح لك فرصة طرح الأسئلة حول المعلومات الواردة في هذا النموذج وحول الاستشارة عن بُعد."
    },

    Expected_Benefits: { English: "Expected Benefits:", Arabic: "الفوائد المتوقعة:" },
    Expected_Benefits_Point1: {
        English: "Improve access to medical care by enabling a patient to remain in their home, office (or a remote site) while your licensed healthcare provider offers you the needed care.",
        Arabic: "تحسين الوصول إلى الرعاية الطبية من خلال تمكينك من البقاء في منزلك أو مكتبك (أو موقع بعيد) بينما يقدم لك مقدم الرعاية الصحية المرخص من هيئة الصحة بدبي، الرعاية اللازمة."
    },
    Expected_Benefits_Point2: {
        English: "More efficient medical evaluation and management.",
        Arabic: "تقييم وإدارة طبية بطريقة فعالة أكثر."
    },

    Possible_Risks: { English: "Possible Risks:", Arabic: "المخاطر المحتملة:" },
    Possible_Risks_Description: {
        English: "As with any medical procedures there are potential risks associated with the use of Telehealth, which may include, but not limited to the following:",
        Arabic: "كما هو الحال مع أي إجراءات طبية، هناك مخاطر محتملة مرتبطة باستخدام التطبيب عن بعد، والتي قد تشمل، على سبيل المثال لا الحصر، ما يلي:"
    },

    Possible_Risks_Point1: {
        English: "Information transmission may not be sufficient (e.g. poor resolution of images) to allow appropriate decision making by the consulted physician.",
        Arabic: "قد لا يكون نقل المعلومات كافياً (على سبيل المثال، ضعف دقة الصور) للسماح باتخاذ القرار المناسب من قبل الطبيب الذي يتم استشارته."
    },
    Possible_Risks_Point2: {
        English: "Delays in medical evaluation and treatment could occur due to deficiencies or failure of internet.",
        Arabic: "قد يحدث تأخير في التقييم الطبي والعلاج بسبب أوجه القصور أو فشل الإنترنت."
    },
    Possible_Risks_Point3: {
        English: "In rare instances, security protocol could fail causing a breach of privacy of personal medical information.",
        Arabic: "في حالات نادرة، قد يفشل بروتوكول الأمان مما يتسبب في خرق خصوصية المعلومات الطبية الشخصية."
    },
    Possible_Risks_Point4: {
        English: "In rare cases, a lack of access to complete health records may result in adverse drug interactions, allergic reactions, or other judgement errors.",
        Arabic: "في حالات نادرة، قد يؤدي عدم القدرة على الوصول إلى السجلات الصحية الكاملة إلى تفاعلات دوائية ضارة أو تفاعلات حساسية أو أخطاء أخرى في الحكم."
    },

    Questions_And_Concerns: { English: "Questions of concerns:", Arabic: "الأسئلة:" },
    Questions_And_Concerns_Section1_Description: {
        English: "You are encouraged to ask questions at any time regarding your assessment and treatment. Bring any concerns you have to your Doctor or Therapist's attention. If you are not comfortable, you may stop treatment at any time. You have the right to have your concerns heard and resolved when possible.",
        Arabic: "نشجعك على طرح الأسئلة في أي وقت بخصوص تقييمك وعلاجك. احضر أي مخاوف لديك إلى انتباه طبيبك. إذا لم تكن مرتاحًا، يمكنك إيقاف العلاج في أي وقت. لديك الحق في أن يتم الاستماع إلى مخاوفك وحلها عندما يكون ذلك ممكنًا."
    },

    Questions_And_Concerns_Section1_Point1: {
        English: "I understand that I have chosen to engage in a video consultation with the purpose of assessing and treating my medical condition and/or obtaining general medical advice.",
        Arabic: "أفهم أنني اخترت المشاركة في استشارة فيديو بغرض تقييم حالتي الطبية وعلاجها و/أو الحصول على مشورة طبية عامة."
    },

    Questions_And_Concerns_Section1_Point2: {
        English: "I confirm that I understand how video consultation technology will be used and this consultation will not be the same as a direct patient/healthcare provider visit since I will not be in the same room as my healthcare provider, hence, they must rely on information provided by me or my onsite healthcare providers.",
        Arabic: "أؤكد أنني أفهم كيف سيتم استخدام تقنية استشارة الفيديو وأن هذه الاستشارة لن تكون مثل زيارة مباشرة للمريض/مقدم الرعاية الصحية حيث لن أكون في نفس الغرفة مع مقدم الرعاية الصحية الخاص بي، وبالتالي، يجب عليهم الاعتماد على المعلومات المقدمة مني أو من مقدمي الرعاية الصحية في الموقع."
    },

    Questions_And_Concerns_Section1_Point3: {
        English: "I understand that I may benefit from teleconsultation, but that results cannot be guaranteed or assured. Additionally, I understand that teleconsultation services and care may not be as complete as in-person services. I also understand that if the teleconsultation doctor believes I would be better served by an in-person consultation, I will be asked to visit a clinic, hospital, or specialist who can provide such services in my area.",
        Arabic: "أفهم أنني قد أستفيد من الاستشارة عن بعد، ولكن لا يمكن ضمان النتائج أو تأكيدها. بالإضافة إلى ذلك، أفهم أن خدمات الاستشارة عن بعد والرعاية قد لا تكون كاملة مثل الخدمات الشخصية. أفهم أيضًا أنه إذا اعتقد طبيب الاستشارة عن بعد أنني سأستفيد بشكل أفضل من الاستشارة الشخصية، فسوف يُطلب مني زيارة عيادة أو مستشفى أو أخصائي يمكنه تقديم مثل هذه الخدمات في منطقتي."
    },

    Questions_And_Concerns_Section2_Description: {
        English: "DISC doctors cannot be responsible for advice, recommendations and/or decisions based on incomplete or inaccurate information provided by me or others.",
        Arabic: "لا يمكن لأطباء DISC أن يكونوا مسؤولين عن النصائح والتوصيات و/أو القرارات المبنية على معلومات غير كاملة أو غير دقيقة قدمتها أنا أو غيري"
    },

    Questions_And_Concerns_Section2_Point1: {
        English: "I understand and I am aware of the alternative treatment options available to me, and I am choosing to participate in a video consultation.",
        Arabic: "أفهم وأدرك خيارات العلاج البديلة المتاحة لي، وأختار المشاركة في استشارة فيديو."
    },

    Questions_And_Concerns_Section2_Point2: {
        English: "I understand that the service is not intended for emergency consultations, and I am aware that I need to contact local emergency services in case of any doubt. In an emergency, I understand that it is my responsibility to seek advice from my local practitioner, and that the teleconsultation provider's responsibility will conclude upon the termination of the video conference.",
        Arabic: "أفهم أن الخدمة غير مخصصة للاستشارات الطارئة وأدرك أنني بحاجة إلى الاتصال بخدمات الطوارئ المحلية في حالة وجود أي شك. في حالة الطوارئ، أفهم أنه من مسؤوليتي إبلاغ طبيبي المحلي وأن مسؤولية مقدم الاستشارة عن بعد ستنتهي عند انتهاء مؤتمر الفيديو."
    },

    Questions_And_Concerns_Section2_Point3: {
        English: "In order to maintain patient-doctor confidentiality I shall under no circumstance record and/or distribute the link or the content of my telehealth consultation to any persons whatsoever.",
        Arabic: "من أجل الحفاظ على سرية العلاقة بين المريض والطبيب، لن أقوم تحت أي ظرف من الظروف بتسجيل و/أو توزيع رابط أو محتوى استشارتي عن بعد لأي شخص مهما كان."
    },

    Questions_And_Concerns_Section2_Point4: {
        English: "I understand that I may withhold or withdraw consent to teleconsultation at any time without affecting my right to future care or treatment.",
        Arabic: "أفهم أنه يجوز لي سحب الموافقة على الاستشارة عن بعد في أي وقت دون التأثير على حقي في الرعاية أو العلاج في المستقبل."
    },

    Questions_And_Concerns_Section2_Point5: {
        English: "I agree that any disputes that arise from the teleconsultation will be resolved as per the laws and regulations and will be raised with the telehealth provider in the first instance.",
        Arabic: "أوافق على أن أي نزاعات تنشأ عن الاستشارة عن بعد سيتم حلها وفقًا لقوانين وأنظمة دولة الإمارات العربية المتحدة وسيتم رفعها إلى مقدم الرعاية الصحية عن بعد في المقام الأول."
    },

    Questions_And_Concerns_Section3_Description: {
        English: "By signing this consent and beginning the video consultation, I certify that:",
        Arabic: "من خلال التوقيع على هذه الموافقة وبدء الاستشارة عبر الفيديو، أقر بأنني:"
    },

    Questions_And_Concerns_Section3_Point1: {
        English: "I have read or had this form read and/or had this form explained to me.",
        Arabic: "قرأت هذا النموذج أو طلبت قراءة هذا النموذج و/أو تم شرحه لي."
    },

    Questions_And_Concerns_Section3_Point2: {
        English: "I fully understand its contents including the risks and benefits of using the service.",
        Arabic: "أفهم محتوياته بالكامل بما في ذلك المخاطر والفوائد المترتبة على استخدام الخدمة."
    },

    Questions_And_Concerns_Section3_Point3: {
        English: "I have been given ample opportunity to ask questions and that any questions have been answered to my satisfaction.",
        Arabic: "أتيحت لي الفرصة الكافية لطرح الأسئلة وأن أي أسئلة تمت الإجابة عليها على النحو الذي يرضيني."
    },

    Questions_And_Concerns_Section3_Point4: {
        English: "I freely give my informed consent and volunteer to engage in this telemedicine consultation.",
        Arabic: "أعطي موافقتي المستنيرة بحرية وأتطوع للمشاركة في استشارة الطب عن بعد هذه."
    },

    Final_Consent_Statement: {
        English: "I hereby acknowledge I understand and consent to receiving care from a Healthcare Provider who is of a different Gender than myself. I consent voluntarily and grant the Healthcare Provider permission to provide the treatment or procedure and understand that I have the right to withdraw from the procedure or treatment at any time without in any way affecting my medical care.",
        Arabic: "أقرّ بموجب هذا بأنني أفهم وأوافق على تلقي الرعاية من مقدم رعاية صحية من جنس مختلف عن جنسّي. أوافق طوعًا وأمنح مقدم الرعاية الصحية الإذن بتقديم العلاج أو الإجراء، وأفهم أن لي الحق في الانسحاب من الإجراء أو العلاج في أي وقت دون أي تأثير على رعايتي الطبية."
    },

    Yes: { English: "Yes", Arabic: "نعم" },
    No: { English: "No", Arabic: "لا" },

    Date: { English: "Date", Arabic: "التاريخ" },
    Patient_Name: { English: "Patient Name", Arabic: "اسم المريض" },
    Patient_Signature: {
        English: "Signature of Patient (or legal guardian)",
        Arabic: "توقيع المريض (أو الوصي)"
    },

    Witness_Statement: {
        English: "I have accurately read or witnessed the accurate reading of the consent form to the potential patient, and the individual has had the opportunity to ask questions. I confirm that the individual has given consent freely.",
        Arabic: "لقد قرأت بدقة أو شهدت القراءة الدقيقة لنموذج الموافقة للمريض المحتمل، وأتيحت للفرد الفرصة لطرح الأسئلة. أؤكد أن الفرد قد أعطى موافقته بحرية"
    },

    Print_Name: {
        English: "Legal Guardian Name",
        Arabic: "اسم الوصي"
    },
    Official_Use_Only: {
        English: "FOR OFFICIAL USE ONLY",
        Arabic: "للاستخدام الرسمي فقط"
    },
    Witness_Statement_Header: {
        English: "Witness Statement",
        Arabic: "بيان الشاهد"
    },
    Witness_Name: {
        English: "Name of Witness",
        Arabic: "اسم الشاهد"
    },
    Witness_Signature: {
        English: "Witness Signature",
        Arabic: "توقيع الشاهد"
    },
    Provider_Name: { English: "Provider's name", Arabic: "اسم مقدم الرعاية الصحية" },
    Provider_Signature: { English: "Signature of Provider", Arabic: "توقيع مقدم الرعاية الصحية" },
    Relationship_To_Patient: { English: "Relationship to Patient", Arabic: "العلاقة بالمريض" },

    Agree: { English: "agree", Arabic: "أوافق" },
    Refuse: { English: "refuse", Arabic: "أرفض" },

    Previous: { English: "Previous", Arabic: "السابق" },
    Next: { English: "Next", Arabic: "التالي" },
    Save: { English: "Save", Arabic: "حفظ" },
    Clear: { English: "Clear", Arabic: "مسح" },

    Signature_Required: { English: "Signature Required", Arabic: "التوقيع مطلوب" },
    Field_Required: { English: "Field cannot be left blank", Arabic: "لا يمكن ترك الحقل فارغًا" },

    // New Psychology-specific sections
    Treatment_Consideration: {
        English: "It is important for you to consider the benefits, risks and alternatives to the treatment options offered by our Clinical Psychologist in order to make an informed decision about proceeding with treatment.",
        Arabic: "من المهم أن تفكر في الفوائد والمخاطر والبدائل لخيارات العلاج التي يقدمها أخصائي علم النفس السريري لدينا من أجل اتخاذ قرار مستنير بشأن المضي قدمًا في العلاج."
    },

    Understanding: {
        English: "I understand:",
        Arabic: "أنا أدرك:"
    },

    Understanding_Point1: {
        English: "Psychological treatment can help in providing new tools to modify thinking, behavior and emotions in order to create positive outcomes in your life.",
        Arabic: "يمكن أن يساعد العلاج النفسي في تقديم أدوات جديدة لتعديل التفكير والسلوك والمشاعر من أجل تحقيق نتائج إيجابية في حياتك."
    },

    Understanding_Point2: {
        English: "I may be encouraged to talk about difficult experiences, and I may experience painful emotions as part of the process.",
        Arabic: "قد يتم تشجيعي على التحدث عن تجارب صعبة، وقد أشعر بمشاعر مؤلمة كجزء من العملية."
    },

    Understanding_Point3: {
        English: "The process of psychological treatment can take time to reach goals.",
        Arabic: "قد تستغرق عملية العلاج النفسي وقتًا للوصول إلى الأهداف المرجوة."
    },

    Understanding_Point4: {
        English: "The content of your sessions with your psychologist is confidential apart from the following exceptions:",
        Arabic: "محتوى جلساتك مع طبيبك النفسي، سري باستثناء الحالات التالية:"
    },

    Understanding_Point4_1: {
        English: "If you are a risk to yourself.",
        Arabic: "إذا كنت تشكل خطرًا على نفسك."
    },

    Understanding_Point4_2: {
        English: "If you are a risk to others.",
        Arabic: "إذا كنت تشكل خطرًا على الآخرين."
    },

    Understanding_Point4_3: {
        English: "If you are involved in a legal case where patient records are subpoenaed.",
        Arabic: "إذا كنت متورطًا في قضية قانونية حيث يتم استدعاء السجلات الطبية للمحكمة."
    },

    Understanding_Point4_4: {
        English: "Your health insurance may request a report which includes diagnosis, nature of treatment and number of sessions. We will only share this information with your insurance provider if you allow us to.",
        Arabic: "قد تطلب شركة التأمين الصحي تقريرًا يتضمن التشخيص وطبيعة العلاج وعدد الجلسات، وسنشارك هذه المعلومات فقط إذا سمحت لنا بذلك."
    },

    Understanding_Point5: {
        English: "If your psychologist needs to break confidentiality according to the cautions above, she or he will always aim to talk to you about this first.",
        Arabic: "إذا احتاج طبيبك النفسي إلى كسر السرية وفقًا للحالات المذكورة أعلاه، فسيحاول دائمًا التحدث إليك أولًا بشأن هذا الأمر."
    },

    Understanding_Point6: {
        English: "If you experience thoughts of harming yourself or others, you will inform your psychologist so that they may assist you.",
        Arabic: "إذا كانت لديك أفكار لإيذاء نفسك أو الآخرين، فعليك إبلاغ طبيبك النفسي حتى يتمكن من مساعدتك."
    },

    Understanding_Point7: {
        English: "If you are deemed to be a risk to yourself or others, DISC will contact the emergency contact person you provided on your registration form for further support.",
        Arabic: "إذا كنت تعتبر خطرًا على نفسك أو الآخرين، فسيقوم DISC بالاتصال بالشخص المؤتمن الذي عرفته في استمارة التسجيل للحصول على دعم إضافي."
    },

    Understanding_Point8: {
        English: "DISC will keep your electronic and hard copy medical records securely according to the DHA (Dubai Health Authority) Medical Records Policy.",
        Arabic: "سيحتفظ DISC بسجلاتك الطبية الإلكترونية والمطبوعة بشكل آمن وفقًا لسياسة سجلات المرضى التابعة لهيئة الصحة في دبي (DHA)."
    },

    Understanding_Point9: {
        English: "Sessions are 50 minutes in duration. Some sessions may be 90 minutes, but this will be discussed with your psychologist if indicated.",
        Arabic: "تستمر الجلسات لمدة 50 دقيقة، وقد تستغرق بعض الجلسات 90 دقيقة، ولكن سيتم مناقشة ذلك مع طبيبك النفسي إذا لزم الأمر."
    },

    Understanding_Point10: {
        English: "I will settle my account prior to or immediately following a session.",
        Arabic: "سأقوم بتسوية حسابي قبل أو فور انتهاء الجلسة."
    },

    Understanding_Point11: {
        English: "We request that you give 6 hours' notice if you cannot make it to your scheduled appointment; please refer to our Cancellation Policy.",
        Arabic: "نطلب منك إشعارًا قبل 6 ساعات إذا لم تتمكن من الحضور إلى موعدك المحدد؛ يرجى الرجوع إلى سياسة الإلغاء الخاصة بنا."
    },

    Understanding_Point12: {
        English: "My participation is voluntary, and I have the right to terminate treatment whenever I would like. I will try and discuss this with my psychologist first, but I am not required to do so.",
        Arabic: "مشاركتي طوعية، ولدي الحق في إنهاء العلاج في أي وقت أرغب فيه. سأحاول مناقشة ذلك مع طبيبي النفسي أولًا، لكنني لست ملزمًا بذلك."
    },

    Understanding_Point13: {
        English: "DISC has the right to end psychological treatment for reasons including but not limited to, failure of the patient to commit and participate in treatment, conflicts of interest, or if we feel we may not be the best person to address your needs, in which case we will endeavor to refer you to a more suitable professional.",
        Arabic: "يحق لـ DISC إنهاء العلاج النفسي لأسباب تشمل، على سبيل المثال لا الحصر، عدم التزام المريض بالعلاج، تضارب المصالح، أو إذا شعرنا بأننا قد لا نكون الأشخاص الأنسب لتلبية احتياجاتك، وفي هذه الحالة سنحاول إحالتك إلى مختص آخر مناسب."
    },

    Psychology_Data_Collection_Header: {
        English: "Data Collection and Privacy",
        Arabic: "جمع البيانات والخصوصية"
    },

    Psychology_Data_Collection_Information: {
        English: "During your treatment at DISC-Dubai, we will gather information about your personal health information. This is limited to: demographic information, medical history, test and lab results, mental health, insurance information and data collected by healthcare professionals. DISC is committed to protecting your personal information in accordance with our Privacy Policy and the laws of the United Arab Emirates.",
        Arabic: "أثناء علاجك في DISC-Dubai، سنقوم بجمع معلومات حول صحتك الشخصية، والتي تقتصر على: المعلومات الديموغرافية، التاريخ الطبي، نتائج الفحوصات والمختبرات، الصحة النفسية، معلومات التأمين، والبيانات التي يجمعها مقدمو الرعاية الصحية. يلتزم DISC-Dubai بحماية معلوماتك الشخصية وفقًا لسياسة الخصوصية الخاصة بنا وقوانين دولة الإمارات العربية المتحدة."
    },
    
    Psychology_Data_Collection_Purpose: {
        English: "We collect, use and disclose personal health information for the primary purpose of safely and effectively providing you with a seamless experience of our services. This disclosure of personal health information shall be disclosed to the following parties and reasons: treatment (defined as: provision, coordination, or management of health care and related services by one or more health care providers, consultation or patient referral between health care providers relating to a patient), healthcare operations, payment and billing, help with public health and safety matters and comply with the law.",
        Arabic: "نقوم بجمع واستخدام والإفصاح عن المعلومات الصحية الشخصية بهدف أساسي يتمثل في تقديم تجربة سلسة وآمنة وفعالة لخدماتنا. يتم الإفصاح عن هذه المعلومات الصحية الشخصية للأطراف التالية وللأسباب التالية: العلاج (ويشمل: تقديم الخدمات الصحية، التنسيق أو إدارة الرعاية الصحية والخدمات ذات الصلة من قبل واحد أو أكثر من مقدمي الرعاية الصحية، الاستشارات أو إحالات المرضى بين مقدمي الرعاية الصحية فيما يتعلق بالمريض)، العمليات الصحية، الدفع والفوترة، المساعدة في قضايا الصحة والسلامة العامة، الامتثال للقانون"
    },
    
    Psychology_Data_Protection_Header: {
        English: "We understand the importance of protecting personal information. For this reason, we have taken the following steps:",
        Arabic: "إجراءات الحماية المتبعة لحماية بياناتك:"
    },
    
    Psychology_Data_Protection_Point1: {
        English: "Paper information is stored in a restricted area at all times",
        Arabic: "يتم تخزين المعلومات الورقية في منطقة مقيدة الوصول في جميع الأوقات."
    },
    
    Psychology_Data_Protection_Point2: {
        English: "Electronic hardware has restricted access at all times",
        Arabic: "الأجهزة الإلكترونية لها وصول مقيد في جميع الأوقات."
    },
    
    Psychology_Data_Protection_Point3: {
        English: "Electronic information is transmitted through direct lines using encryption and marked as 'personal and confidential'.",
        Arabic: "يتم نقل المعلومات الإلكترونية عبر خطوط مشفرة وموسومة بـ \"شخصي وسري\"."
    },
    
    Psychology_Data_Protection_Point4: {
        English: "Staff is trained to collect, use, and disclose personal information, as stated above as necessary to fulfill their duties in accordance with our privacy policies.",
        Arabic: "يتم تدريب الموظفين على جمع واستخدام والكشف عن المعلومات الشخصية وفقًا لسياستنا الخاصة بالخصوصية."
    },
    
    Psychology_Data_Protection_Point5: {
        English: "External consultants and agencies with access to personal information (Insurance companies) must enter into privacy agreements with us.",
        Arabic: "يُطلب من المستشارين الخارجيين والشركات (مثل شركات التأمين) توقيع اتفاقيات خصوصية."
    },
    
    Psychology_Data_Protection_Point6: {
        English: "All your information is retained as necessary to provide services and in compliance with the applicable laws.",
        Arabic: "يتم الاحتفاظ بجميع معلوماتك طالما كان ذلك ضروريًا لتقديم الخدمات والامتثال للقوانين المعمول بها."
    },
    
    Psychology_Data_Sharing: {
        English: "* We do not share personal information with any agencies not directly related to your treatment care and we do not provide our patient's information to solicitors.",
        Arabic: "* نحن لا نشارك معلوماتك الشخصية مع أي جهات غير مرتبطة برعايتك الصحية، كما أننا لا نقدم معلومات المرضى إلى المحامين."
    },
    
    Psychology_Marketing: {
        English: "* Marketing – we will obtain your written authorization before using your health information to send marketing materials",
        Arabic: "* التسويق: سنحصل على موافقتك الخطية قبل استخدام معلوماتك الصحية في أي مواد تسويقية."
    },
    
    Psychology_Patient_Rights_Header: {
        English: "You have the right to:",
        Arabic: "لديك الحق في:"
    },
    
    Psychology_Patient_Rights_Point1: {
        English: "Get a copy of your paper or electronic medical record",
        Arabic: "الحصول على نسخة من سجلك الطبي الورقي أو الإلكتروني."
    },
    
    Psychology_Patient_Rights_Point2: {
        English: "Request confidential communications – you can make a written request that we communicate with you about medical matters in a certain way. For example, you may request that we contact you only in writing.",
        Arabic: "طلب تواصل سري – يمكنك تقديم طلب كتابي بأن يتم الاتصال بك بشأن الأمور الطبية بطريقة معينة. على سبيل المثال، يمكنك طلب أن يتم التواصل معك كتابيًا فقط."
    },
    
    Psychology_Patient_Rights_Point3: {
        English: "Be notified of a breach – we will notify you in the event of a breach of your protected health information.",
        Arabic: "تلقي إشعار بحدوث خرق – سنقوم بإبلاغك في حالة حدوث خرق لمعلوماتك الصحية المحمية."
    },
    
    Psychology_Patient_Rights_Point4: {
        English: "Request to correct or amend your health information - you have the right to request in writing that personal health information that we maintain about you be amended or corrected only if the information we have is incorrect and/or does not reflect updated information. We are not obligated to make all requested amendments but will give each careful consideration.",
        Arabic: "طلب تصحيح أو تعديل معلوماتك الصحية – لديك الحق في تقديم طلب كتابي لتعديل أو تصحيح المعلومات الصحية الشخصية التي نحتفظ بها عنك، ولكن فقط إذا كانت المعلومات غير صحيحة أو لا تعكس بيانات محدثة. لسنا ملزمين بإجراء جميع التعديلات المطلوبة، ولكننا سننظر في كل طلب بعناية."
    },
    
    Psychology_Patient_Rights_Point5: {
        English: "Revoke your Consent prior to the commencement of your procedure, intervention or treatment.",
        Arabic: "إلغاء موافقتك قبل بدء أي إجراء أو تدخل طبي أو علاج."
    },
    
    Psychology_Patient_Rights_Point6: {
        English: "Get a copy of this privacy notice.",
        Arabic: "الحصول على نسخة من إشعار الخصوصية هذا."
    },
    
    Psychology_Questions_Concerns: {
        English: "Questions or concerns",
        Arabic: "الأسئلة أو الشكاوى"
    },
    
    Psychology_Questions_Concerns_Description: {
        English: "You are encouraged to ask questions at any time regarding your assessment and treatment. Bring any concerns you have to your Healthcare Provider's attention. If you are not comfortable, you may stop treatment at any time. You have the right to have your concerns heard and resolved when possible.",
        Arabic: "يمكنك طرح الأسئلة في أي وقت بخصوص تقييمك وعلاجك. في حال وجود أي مخاوف، يرجى مناقشتها مع مقدم الرعاية الصحية الخاص بك. إذا كنت غير مرتاح، يمكنك التوقف عن العلاج في أي وقت. لديك الحق في سماع مخاوفك ومعالجتها قدر الإمكان."
    },
    
    Psychology_Complaints_Header: {
        English: "Complaints",
        Arabic: "تقديم الشكاوى"
    },
    
    Psychology_Complaints_Description: {
        English: "Patients have a right to voice complaints about their care or experience at the clinic and to have those complaints reviewed and, when possible, resolved. An internal complaint form is available at our front reception.",
        Arabic: "يحق للمرضى تقديم شكاوى حول رعايتهم أو تجربتهم في العيادة وأن تتم مراجعة هذه الشكاوى وحلها إن أمكن. تتوفر استمارة شكوى داخلية في مكتب الاستقبال الأمامي."
    },
    
    Psychology_Complaints_DHA: {
        English: "If you are not happy with how your concern is resolved, you may file a complaint with Dubai Health Authorities by calling 800342 (800 DHA), or by accessing the online complaint system via https://www.dha.gov.ae/",
        Arabic: "إذا لم تكن راضيًا عن كيفية حل مشكلتك، يمكنك تقديم شكوى إلى هيئة الصحة في دبي (DHA) عبر الاتصال على 800342 (800 (DHA أو من خلال النظام الإلكتروني لتقديم الشكاوى عبر الموقع الإلكتروني https://www.dha.gov.ae/"
    },
    
    Psychology_Patient_Responsibility: {
        English: "Please be involved in and responsible for your care. Inform your Healthcare Provider immediately of any change in your condition.",
        Arabic: "يرجى المشاركة في مسؤولية رعايتك. أبلغ مقدم الرعاية الصحية الخاص بك فورًا عن أي تغيير في حالتك الصحية."
    },
    
    Psychology_Final_Acknowledgment: {
        English: "I hereby acknowledge I understand the nature of the treatment to be provided to me. I have considered the benefits and risks of treatment, as well as the alternatives to treatment. I hereby consent to Psychology treatment as proposed to me. I grant Diversified and Integrated Sports Clinic-Dubai permission to contact me directly via telephone, text message or email to discuss any matter that may arise in the future.",
        Arabic: "أنا أقر بأنني أفهم طبيعة العلاج المقترح لي. لقد نظرت في فوائد العلاج ومخاطره، وكذلك البدائل المتاحة. أوافق بموجب هذا على تلقي العلاج النفسي كما تم اقتراحه لي. أسمح لـ Diversified and Integrated Sports Clinic-Dubai بالاتصال بي مباشرة عبر الهاتف أو الرسائل النصية أو البريد الإلكتروني لمناقشة أي مسألة قد تنشأ في المستقبل."
    },
    
    Psychology_Data_Understanding: {
        English: "I understand that to provide me with Psychology services, Diversified Integrated Sports Clinic-Dubai is required to collect personal information. I understand the collection, use, and disclosure of this personal information, and I have been given the chance to ask questions with respect to clarification.",
        Arabic: "أنا أفهم أن تقديم الخدمات النفسية لي يتطلب جمع معلومات شخصية. لقد تم إبلاغي عن كيفية جمع واستخدام والكشف عن هذه المعلومات، وأتيحت لي الفرصة لطرح الأسئلة لتوضيح أي استفسار."
    }
});

export default PsychologyFormTextEnum; 